module.exports = __webpack_public_path__ + "img/18_51.f7da6999.png";